<div class="loader"><mat-spinner color="warn"></mat-spinner><span class="text">{{ message }}</span>
    <div class="loader-note"> <span class="font-semibold">Note: </span> <span class="italic">Please do not close until the process is completed.</span> </div>
</div>